const GermanVATIncluded = ({ storeCode }) =>
  storeCode === "DE" ? "inkl. MwSt." : null;

export default GermanVATIncluded;



// WEBPACK FOOTER //
// ./template/components/MiniBag/Footer/SubTotal/GermanVATIncluded/GermanVATIncluded.js